import {Component} from '@angular/core';

@Component({
  selector: 'app-resource-text',
  templateUrl: './resource-text.component.html',
  styleUrls: ['./resource-text.component.css']
})
export class ResourceTextComponent {
  data: any
}
